import { render, staticRenderFns } from "./WaitingDots.vue?vue&type=template&id=0af55f8e&"
import script from "./WaitingDots.vue?vue&type=script&lang=js&"
export * from "./WaitingDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports